/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  ProductQuantityDiscountCreateBody,
  ProductQuantityDiscountDetailResponse,
  ProductQuantityDiscountItem,
  ProductQuantityDiscountListResponse,
} from "../types"

export class ProductQuantityDiscount {
  private client: unknown

  constructor(client: unknown) {
    this.client = client
  }

  create(
    vendorId: string,
    productId: string,
    body: ProductQuantityDiscountCreateBody,
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<ProductQuantityDiscountItem> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/products/${productId}/quantity-discount`,
        {
          method: "POST",
          headers,
          body,
          query,
        }
      )
    })()
  }

  update(
    id: string,
    vendorId: string,
    productId: string,
    body: ProductQuantityDiscountCreateBody,
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<ProductQuantityDiscountItem> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/products/${productId}/quantity-discount/${id}`,
        {
          method: "PUT",
          headers,
          body,
          query,
        }
      )
    })()
  }

  list(
    vendorId: string,
    productId: string,
    queryParams?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<ProductQuantityDiscountListResponse> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/products/${productId}/quantity-discount`,
        {
          headers,
          query: queryParams,
        }
      )
    })()
  }

  retrieve(
    id: string,
    queryParams?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<ProductQuantityDiscountDetailResponse> {
    return (async () => {
      const { vendorId, productId, ...reset } = queryParams as any
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/products/${productId}/quantity-discount/${id}`,
        {
          query: reset,
          headers,
        }
      )
    })()
  }

  delete(
    id: string,
    vendorId: string,
    productId: string,
    headers?: Record<string, unknown>
  ): Promise<unknown> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/products/${productId}/quantity-discount/${id}`,
        {
          method: "DELETE",
          headers,
        }
      )
    })()
  }
}
